import React from 'react';
import {Banner, Benefit, Feature, Header, Question, Sites} from "./components";
import styles from './Home.module.scss';
import useBodyScroll from "./hooks/useBodyScroll";
import HomeContext from "./HomeContext";
import {Footer} from "../common";

export const Home = ({isAuthenticated, onSignOutAction, userInfo}) => {
  const [bodyScrollTop, setBodyScrollTop] = useBodyScroll("home-body");

  const contextValue = React.useMemo(
    () => ({bodyScrollTop, setBodyScrollTop}),
    [bodyScrollTop, setBodyScrollTop],
  );

  return (
    <div className={styles.container} id="home-body">
      <HomeContext.Provider value={contextValue}>
        <Header isAuthenticated={isAuthenticated} onSignOut={onSignOutAction} userInfo={userInfo}/>
        <Banner/>
        <Feature/>
        <Benefit/>
        <Question/>
        <Sites/>
        <Footer/>
      </HomeContext.Provider>
    </div>
  );
};

export default Home;
